const questions =
    [
        {
            question: "Tell me something specific you have lost more than once",
            answers: [
                ["Keys", 63],
                ["Money", 7],
                ["Weight", 5],
                ["Contact Lens", 4],
                ["Eyeglasses", 4],
                ["Wallet", 3],
                ["Earring", 2]
            ]
        }, {
            question: "Name a toy you always see in pictures of Santa's Workshop",
            answers: [
                ["Doll", 39],
                ["Stuffed Animal", 13],
                ["Train", 11],
                ["Rocking Horse", 9],
                ["Toy Soldier", 9],
                ["Drum", 4],
                ["Ball", 3],
                ["Wagon", 3]
            ]
        },
        // {
        //     question: "Name Something You Fill With Air",
        //     answers: [
        //         ["Balloons", 55],
        //         ["Tires", 20],
        //         ["Airbags", 8],
        //         ["Lungs", 7],
        //         ["Ball", 5],
        //         ["Air Mattress", 5]
        //     ]
        // }, 
        {
            question: "Name a kind of food that gets stuck between your teeth",
            answers: [
                ["Corn", 37],
                ["Meat", 23],
                ["Popcorn", 22],
                ["Caramel", 6],
                ["Nuts", 3],
                ["Peanut Butter", 3],
                ["Taffy", 2]
            ]
        },
        // {
        //     question: "Name something the police do at the station to those who are arrested",
        //     answers: [
        //         ["Fingerprint Them", 56],
        //         ["Book Them", 20],
        //         ["Question", 5],
        //         ["Mug Shot", 5],
        //         ["Give One Phone Call", 3],
        //         ["Put Then in Cell", 3],
        //         ["Read Their Rights", 2]
        //     ]
        // }, 
        {
            question: "Name a place that always has a pay phone",
            answers: [
                ["Restaurant", 26],
                ["Gas Station", 24],
                ["Airport", 22],
                ["Hospital", 7],
                ["Hotel", 6],
                ["Mall", 6],
                ["Grocery", 4]
            ]
        }, {
            question: "Name the smartest animal",
            answers: [
                [
                    "Dog",
                    29
                ],
                [
                    "Monkey",
                    21
                ],
                [
                    "Dolphin",
                    16
                ],
                [
                    "Cat",
                    14
                ],
                [
                    "Fox",
                    5
                ],
                [
                    "Horse",
                    4
                ],
                [
                    "Parrot",
                    3
                ]
            ],
        }, {
            question: "Name something people do when they have extra time in the morning",
            answers: [
                [
                    "Read",
                    53
                ],
                [
                    "Sleep",
                    10
                ],
                [
                    "Eat",
                    9
                ],
                [
                    "Exercise",
                    8
                ],
                [
                    "Watch TV",
                    6
                ],
                [
                    "Drink Coffee",
                    5
                ],
                [
                    "Clean",
                    3
                ]
            ],
        }, {
            question: "Besides clothing, name something that has a pocket",
            answers: [
                [
                    "Kangaroo",
                    36
                ],
                [
                    "Purse",
                    23
                ],
                [
                    "Pool Table",
                    13
                ],
                [
                    "Bread",
                    10
                ],
                [
                    "Car Door",
                    7
                ],
                [
                    "Diaper Bag",
                    2
                ],
                [
                    "Tool Belt",
                    2
                ]
            ],
        }, {
            question: "Besides a gift, name something that you give someone on their birthday",
            answers: [
                [
                    "Card",
                    46
                ],
                [
                    "Kiss",
                    19
                ],
                [
                    "Cake",
                    15
                ],
                [
                    "Party",
                    6
                ],
                [
                    "Hug",
                    3
                ],
                [
                    "Spanking",
                    3
                ],
                [
                    "Call",
                    2
                ]
            ],
        }, {
            question: "Name a place in front of which people double park for a minute",
            answers: [
                [
                    "Post Office",
                    50
                ],
                [
                    "Store",
                    14
                ],
                [
                    "Bank",
                    9
                ],
                [
                    "Hospital",
                    7
                ],
                [
                    "Dry Cleaners",
                    6
                ],
                [
                    "Airport",
                    5
                ],
                [
                    "School",
                    5
                ]
            ],
        }, {
            question: "Name a food you wouldn't or couldn't eat with your fingers",
            answers: [
                [
                    "Spaghetti",
                    34
                ],
                [
                    "Soup",
                    23
                ],
                [
                    "Mashed Potatoes",
                    13
                ],
                [
                    "Ice Cream",
                    10
                ],
                [
                    "Pudding",
                    8
                ],
                [
                    "Peas",
                    4
                ],
                [
                    "Steak",
                    2
                ]
            ],
        }, {
            question: "Name a stationary item people sneak home from the office",
            answers: [
                [
                    "Pens",
                    56
                ],
                [
                    "Paper Clips",
                    14
                ],
                [
                    "Paper",
                    11
                ],
                [
                    "Envelopes",
                    10
                ],
                [
                    "Stamps",
                    3
                ],
                [
                    "Tape",
                    3
                ],
                [
                    "Rubber Bands",
                    2
                ],
                [
                    "Staples",
                    1
                ]
            ],
        }, {
            question: "Name something that people must be taught to hold correctly",
            answers: [
                [
                    "Pencil",
                    41
                ],
                [
                    "Silverware",
                    28
                ],
                [
                    "Golf Club",
                    9
                ],
                [
                    "Baby",
                    7
                ],
                [
                    "Chopsticks",
                    5
                ],
                [
                    "Gun",
                    2
                ],
                [
                    "Baseball Bat",
                    2
                ]
            ],
        }, {
            question: "Name something people try to peek through",
            answers: [
                [
                    "Keyhole",
                    36
                ],
                [
                    "Window",
                    14
                ],
                [
                    "Peephole",
                    10
                ],
                [
                    "Curtain",
                    9
                ],
                [
                    "Fence",
                    9
                ],
                [
                    "Crack In Door",
                    6
                ],
                [
                    "Envelope",
                    3
                ]
            ],
        }, {
            question: "Name something you use in the mornings",
            answers: [
                [
                    "Coffee Maker",
                    29
                ],
                [
                    "Hair Dryer",
                    22
                ],
                [
                    "Razor",
                    16
                ],
                [
                    "Toaster",
                    13
                ],
                [
                    "Curling Iron",
                    7
                ],
                [
                    "Alarm",
                    4
                ],
                [
                    "Oven",
                    4
                ],
                [
                    "Lights",
                    3
                ]
            ],
        }, {
            question: "Name an occupation in which you might be required to ride a horse",
            answers: [
                [
                    "Jockey",
                    38
                ],
                [
                    "Police",
                    37
                ],
                [
                    "Cowboy",
                    15
                ],
                [
                    "Forest Ranger",
                    3
                ],
                [
                    "Horse Trainer",
                    3
                ]
            ],
        }, {
            question: "Past or present, name a famous artist",
            answers: [
                [
                    "Pablo Picasso",
                    27
                ],
                [
                    "Vincent Van Gogh",
                    20
                ],
                [
                    "Leonardo Da Vinci",
                    19
                ],
                [
                    "Michelangelo",
                    10
                ],
                [
                    "Rembrandt Van Rijn",
                    9
                ],
                [
                    "Auguste Renoir",
                    3
                ],
                [
                    "Norman Rockwell",
                    3
                ]
            ],
        }, {
            question: "Name something you'd cry over losing",
            answers: [
                [
                    "Wedding Ring",
                    41
                ],
                [
                    "Loved One",
                    22
                ],
                [
                    "Pet",
                    9
                ],
                [
                    "Wallet",
                    7
                ],
                [
                    "Home",
                    4
                ],
                [
                    "Job",
                    4
                ],
                [
                    "Purse",
                    3
                ]
            ],
        }, {
            question: "Name something you might forget in a restaurant",
            answers: [
                [
                    "Purse",
                    27
                ],
                [
                    "Coat",
                    15
                ],
                [
                    "To Leave A Tip",
                    14
                ],
                [
                    "Hat",
                    13
                ],
                [
                    "Umbrella",
                    11
                ],
                [
                    "Keys",
                    5
                ],
                [
                    "Glasses",
                    4
                ],
                [
                    "Doggy Bag",
                    3
                ]
            ],
        }, {
            question: "Name a state with two words in its name",
            answers: [
                [
                    "New York",
                    46
                ],
                [
                    "North Carolina",
                    11
                ],
                [
                    "Rhode Island",
                    9
                ],
                [
                    "New Mexico",
                    8
                ],
                [
                    "New Jersey",
                    6
                ],
                [
                    "West Virginia",
                    6
                ],
                [
                    "North Dakota",
                    5
                ],
                [
                    "New Hampshire",
                    4
                ]
            ]
        }, {
            question: "Name something that's hardest to do the first time you try it",
            answers: [
                [
                    "Ride a Bicycle",
                    24
                ],
                [
                    "Ski",
                    21
                ],
                [
                    "Drive",
                    18
                ],
                [
                    "Skate",
                    7
                ],
                [
                    "Swim",
                    6
                ]
            ],
        }, {
            question: "Name something you use every day",
            answers: [
                [
                    "Toothbrush",
                    41
                ],
                [
                    "Soap",
                    10
                ],
                [
                    "Car",
                    8
                ],
                [
                    "Telephone",
                    7
                ],
                [
                    "Water",
                    5
                ],
                [
                    "Bathroom",
                    3
                ],
                [
                    "Deodorant",
                    3
                ],
                [
                    "Hairbrush",
                    3
                ]
            ]
        }, {
            question: "Name something that puts people to sleep",
            answers: [
                [
                    "Medication",
                    22
                ],
                [
                    "Reading",
                    16
                ],
                [
                    "Music",
                    14
                ],
                [
                    "TV",
                    12
                ],
                [
                    "Milk",
                    8
                ],
                [
                    "Anesthesia",
                    5
                ],
                [
                    "Dull Movie",
                    5
                ],
                [
                    "Lecture",
                    4
                ]
            ]
        }, {
            question: "Name something in the house that is very difficult to move",
            answers: [
                [
                    "Refrigerator",
                    42
                ],
                [
                    "Piano",
                    14
                ],
                [
                    "Couch",
                    12
                ],
                [
                    "Bed",
                    9
                ],
                [
                    "Dresser",
                    5
                ],
                [
                    "TV",
                    5
                ],
                [
                    "Stove",
                    3
                ]
            ],
        }, {
            question: "Name something you buy frozen",
            answers: [
                [
                    "Ice Cream",
                    40
                ],
                [
                    "Vegetables",
                    21
                ],
                [
                    "TV Dinner",
                    16
                ],
                [
                    "Pizza",
                    6
                ],
                [
                    "Fish",
                    5
                ],
                [
                    "Juice",
                    5
                ],
                [
                    "Yogurt",
                    3
                ],
                [
                    "Ice",
                    2
                ]
            ],
        }, {
            question: "Name a place where you see nervous people",
            answers: [
                [
                    "Dentist's Office",
                    34
                ],
                [
                    "Hospital",
                    20
                ],
                [
                    "Doctor",
                    18
                ],
                [
                    "Court",
                    7
                ],
                [
                    "IRS Office",
                    6
                ],
                [
                    "Wedding",
                    3
                ],
                [
                    "Airport",
                    2
                ],
                [
                    "Job Interview",
                    2
                ]
            ],
        }, {
            question: "Besides King & Queen name a title some people have in England",
            answers: [
                [
                    "Prince",
                    32
                ],
                [
                    "Duke",
                    23
                ],
                [
                    "Princess",
                    17
                ],
                [
                    "Lord",
                    11
                ],
                [
                    "Duchess",
                    9
                ],
                [
                    "Sir",
                    4
                ],
                [
                    "Earl",
                    1
                ],
                [
                    "Lady",
                    1
                ]
            ],
        }, {
            question: "Name something you'd take with you for an afternoon in the park",
            answers: [
                [
                    "Picnic",
                    36
                ],
                [
                    "Blanket",
                    21
                ],
                [
                    "Book",
                    17
                ],
                [
                    "Radio",
                    8
                ],
                [
                    "Frisbee",
                    4
                ],
                [
                    "Sunglasses",
                    3
                ],
                [
                    "Camera",
                    2
                ],
                [
                    "Chair",
                    2
                ]
            ],
        }, {
            question: "Name something that easy to do forwards, but hard backwards",
            answers: [
                [
                    "Walk",
                    24
                ],
                [
                    "Run",
                    19
                ],
                [
                    "Drive",
                    14
                ],
                [
                    "Write",
                    11
                ],
                [
                    "Skate",
                    10
                ],
                [
                    "Ride Bicycle",
                    9
                ],
                [
                    "Talk",
                    4
                ]
            ],
        }
    ]


export default { questions };